import React from 'react';

import WsIconProps from './IconProps';

const Submitted: React.FC<WsIconProps> = ({
  color = '#F2FBFD',
  color2 = '#12EDE3',
  width = 24,
  height = 24,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z"
      fill={color}
    />
    <circle cx="11.9034" cy="8.47087" r="3.22087" fill={color2} />
    <path
      d="M17.0568 17.4893C17.0568 16.1226 16.5139 14.8118 15.5474 13.8453C14.581 12.8789 13.2702 12.3359 11.9034 12.3359C10.5366 12.3359 9.22585 12.8789 8.2594 13.8453C7.29295 14.8118 6.75 16.1226 6.75 17.4893L11.9034 17.4893H17.0568Z"
      fill={color2}
    />
    <path
      d="M19.6411 14.5986L20.3482 13.8915L19.6411 13.1844L18.7301 12.2734L18.023 11.5663L17.3159 12.2734L13.3251 16.2642L12.8773 15.8163L12.1702 15.1092L11.463 15.8163L10.552 16.7273L9.84494 17.4344L10.552 18.1415L12.618 20.2075L13.3251 20.9146L14.0322 20.2075L19.6411 14.5986Z"
      fill={color2}
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export default Submitted;
